import React, { memo } from "react";
import { withRouter } from "react-router-dom";
import Version from "./subComponents/Version";
// import LoggedUser from "./subComponents/LoggedUser";
import TokenRefresh from "../../../auth/components/TokenRefresh";

const Body = withRouter(({ children, history }) => {
    return (
        <>
            <Version history={history} />
            {/* <LoggedUser history={history} /> */}
            <TokenRefresh />
            {children}
        </>
    );
});

export default memo(Body);
